//import utils from "./utils.js";
import type { Component, ComponentPublicInstance } from "vue";
import { isVueElement } from "../../../shared/utils/element";

export function getAllVueElements(element: Element, array: Element[] = []) {
    for (const child of Array.from(element.children)) {
        if (isVueElement(child, false)) {
            array.push(child);
        }
        getAllVueElements(child, array);
    }
    return array;
}

export type Validation = {
    valid: boolean | (() => boolean);
    report: () => void;
    origin: any;
};
const componentStorage: { component: any; data: Validation }[] = [];

export function validate(validation: Validation) {
    if (typeof validation.valid === "boolean") return validation.valid;
    if (typeof validation.valid === "function") return validation.valid();
    return false;
}

export function reportValidity(validation: Validation) {
    if (typeof validation.report === "function") validation.report();
    else console.error("Missing report method");
}

export function getInvalidItems(validations: Validation[]) {
    const invalidItems = [];
    for (const validation of validations) {
        if (!validate(validation)) invalidItems.push(validation);
    }
    return invalidItems;
}

export function getLegacyFormSubmitValidation(form: Element) {
    if (typeof form != "object" || form.tagName.toUpperCase() !== "FORM") {
        throw new Error("Provided parameter is not form");
    }

    const vueElements = getAllVueElements(form);

    const validations: Validation[] = [];

    for (const vueElement of vueElements) {
        const matches = componentStorage.filter((item) => {
            const vueElementVue = vueElement as {
                __Vue__?: null | undefined | Component;
            };
            return (
                (vueElementVue != null && item.component === vueElementVue) ||
                (item.component.$el != null &&
                    item.component.$el === vueElement) ||
                (item.component.$el.__vue__ != null &&
                    item.component.$el.__vue__ === vueElementVue)
            );
        });
        if (matches.length > 0) {
            for (const match of matches) {
                validations.push(match.data);
            }
        }
    }

    return validations;
}

export function storeLegacyFormSubmitValidation(
    component: Component | ComponentPublicInstance,
    valid: Validation["valid"],
    report: Validation["report"]
) {
    if (component == null) {
        throw new Error("missing component");
    }
    const data = { valid, report, origin: component };
    componentStorage.push({ component, data: data });
    return data;
}
